<div class="fullscreen-dialog-wrapper">
  <h1 mat-dialog-title>
    <div class="dialog-header-content">
      <span class="dialog-header-name">{{ newUser() ? 'Nieuwe medewerker' : user().name }}</span>
      @if (!newUser()) {
        <p class="dialog-header-email">{{ user().email }}</p>
      }
    </div>
    <button mat-icon-button class="dialog-close" aria-label="Sluiten" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div mat-dialog-content>
    <form (ngSubmit)="save()" [formGroup]="userForm">
      <div class="dialog-scroll-content">
        <section class="form-section">
          <h2>Persoonsgegevens</h2>
          <div class="fields-grid">
            @if (newUser()) {
              <mat-form-field>
                <mat-label>E-mail</mat-label>
                <input formControlName="email" autocomplete="one-time-code" type="email" matInput required />
                @if (userForm.controls.email.errors?.required) {
                  <mat-error>Je moet dit veld invullen.</mat-error>
                }
                @if (userForm.controls.email.errors?.email || userForm.controls.email.errors?.customError) {
                  <mat-error>E-mailadres is ongeldig.</mat-error>
                }
              </mat-form-field>
            }
            <mat-form-field>
              <mat-label>Voor- & achternaam</mat-label>
              <input formControlName="name" type="name" matInput required />
              @if (userForm.controls.name.errors?.required) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Telefoonnummer</mat-label>
              <input formControlName="phone" type="tel" matInput required />
              @if (userForm.controls.phone.errors?.required) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
              @if (userForm.controls.phone.hasError('phoneValidator')) {
                <mat-error>Telefoonnummer is ongeldig.</mat-error>
              }
            </mat-form-field>
          </div>
        </section>
        @if (newUser()) {
          <section class="form-section">
            <h2>Accounttoegang</h2>
            <mat-form-field>
              <mat-label>Wachtwoord</mat-label>
              <input formControlName="password" autocomplete="new-password" matInput required />
              <button
                mat-icon-button
                matSuffix
                type="button"
                aria-label="Genereer willekeurig wachtwoord"
                (click)="generatePassword()"
                matTooltip="Genereer een willekeurig wachtwoord"
              >
                <mat-icon>autorenew</mat-icon>
              </button>
              @if (userForm.controls.password.errors?.required) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
          </section>
        }
        <section class="form-section">
          <h2>Rollen en status</h2>
          <mat-form-field [class.mat-form-field-no-subscript]="!newUser()">
            <mat-label>Rollen</mat-label>
            <mat-select formControlName="roles" multiple>
              <mat-select-trigger>
                <mat-chip-set>
                  @for (role of userForm.controls.roles.value; track role) {
                    <mat-chip>{{ getRoleLabel(role) }}</mat-chip>
                  }
                </mat-chip-set>
              </mat-select-trigger>
              <mat-option [value]="Role.Administrator">Administrator</mat-option>
              <mat-option [value]="Role.Planner">Planner</mat-option>
              <mat-option [value]="Role.RidePlanner">Ritplanner</mat-option>
              <mat-option [value]="Role.Driver">Chauffeur</mat-option>
              @if (dataStore.generalSettings.coDriverEnabled) {
                <mat-option [value]="Role.CoDriver">Bijrijder</mat-option>
              }
              <mat-option [value]="Role.Other">Overige</mat-option>
            </mat-select>
            @if (userForm.controls.roles.errors?.required) {
              <mat-error>Je moet minimaal één rol selecteren.</mat-error>
            }
          </mat-form-field>
          @if (!newUser()) {
            <div class="field-info">Als je geen rollen selecteert, wordt de medewerker inactief gemaakt.</div>
            <mat-slide-toggle formControlName="passenger">Medewerker is ook een passagier</mat-slide-toggle>
          }
        </section>
        @if (hasPersonalDataAccess) {
          <section class="form-section">
            <h2>Adresgegevens</h2>
            <div class="fields-row static-row">
              <mat-form-field>
                <mat-label>Postcode</mat-label>
                <input formControlName="postal" matInput required />
                @if (userForm.controls.postal.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.postal.hasError('postalValidator')) {
                  <mat-error>Postcode is ongeldig.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Huisnummer</mat-label>
                <input formControlName="houseNumber" matInput required />
                @if (userForm.controls.houseNumber.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
                @if (userForm.controls.houseNumber.hasError('numberInput')) {
                  <mat-error>Huisnummer is ongeldig.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Toevoeging</mat-label>
                <input formControlName="houseNumberAddition" matInput />
                <mat-hint>Optioneel</mat-hint>
              </mat-form-field>
            </div>
            <div class="fields-row">
              <mat-form-field class="double-width">
                <mat-label>Straatnaam</mat-label>
                <input formControlName="streetName" matInput required />
                @if (isLookingUp()) {
                  <div matSuffix class="lookup-spinner">
                    <mat-spinner diameter="20"></mat-spinner>
                  </div>
                }
                @if (userForm.controls.streetName.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Woonplaats</mat-label>
                <input formControlName="city" matInput required />
                @if (isLookingUp()) {
                  <div matSuffix class="lookup-spinner">
                    <mat-spinner diameter="20"></mat-spinner>
                  </div>
                }
                @if (userForm.controls.city.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
            </div>
            @if (addressNotFound()) {
              <div class="address-warning">
                <mat-icon>warning</mat-icon>
                <span>
                  Adres niet gevonden. Controleer of de postcode en het huisnummer correct zijn ingevuld of vul
                  handmatig de straatnaam en woonplaats in.
                </span>
              </div>
            }
          </section>
          <section class="form-section">
            <h2>Opmerkingen</h2>
            <mat-form-field>
              <mat-label>Opmerking (Algemeen)</mat-label>
              <textarea formControlName="hiddenRemarks" matInput rows="3"></textarea>
              <mat-hint>Optioneel</mat-hint>
            </mat-form-field>
          </section>
          <section class="form-section">
            <h2>Medewerkergegevens</h2>
            <div class="fields-grid">
              <mat-form-field>
                <mat-label>Startdatum</mat-label>
                <input formControlName="startDate" matInput [matDatepicker]="startDatePicker" required />
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
                @if (hasDateParseError('startDate')) {
                  <mat-error>Vul een geldige datum in.</mat-error>
                } @else if (userForm.controls.startDate.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>VOG-datum</mat-label>
                <input formControlName="vogDate" matInput [matDatepicker]="vogDatePicker" required />
                <mat-datepicker-toggle matSuffix [for]="vogDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #vogDatePicker></mat-datepicker>
                @if (hasDateParseError('vogDate')) {
                  <mat-error>Vul een geldige datum in.</mat-error>
                } @else if (userForm.controls.vogDate.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                } @else if (userForm.controls.vogDate.hasError('futureDate')) {
                  <mat-error>De datum mag niet in de toekomst liggen.</mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Rijtestdatum</mat-label>
                <input formControlName="driversTestDate" matInput [matDatepicker]="driversTestDatePicker" required />
                <mat-datepicker-toggle matSuffix [for]="driversTestDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #driversTestDatePicker></mat-datepicker>
                @if (hasDateParseError('driversTestDate')) {
                  <mat-error>Vul een geldige datum in.</mat-error>
                } @else if (userForm.controls.driversTestDate.hasError('required')) {
                  <mat-error>Dit veld is verplicht.</mat-error>
                } @else if (userForm.controls.driversTestDate.hasError('futureDate')) {
                  <mat-error>De datum mag niet in de toekomst liggen.</mat-error>
                }
              </mat-form-field>
            </div>
          </section>
        }
        @if (canShowEmployeePhotos) {
          <section class="form-section">
            <h2>Profielfoto</h2>
            <div class="employee-photo-upload">
              <div
                class="upload-preview"
                role="button"
                tabindex="0"
                aria-label="Profielfoto uploaden"
                matTooltip="Klik om een profielfoto te uploaden"
                matTooltipClass="wide-tooltip"
                (click)="photoInput.click()"
                (keydown.enter)="photoInput.click()"
                (keydown.space)="$event.preventDefault(); photoInput.click()"
              >
                @if (photoPreviewUrl()) {
                  <img [src]="photoPreviewUrl()" alt="Profielfoto" />
                } @else {
                  <div class="circle-icon primary-bg" aria-hidden="true">
                    {{ (user()?.name ?? userForm?.controls.name?.value ?? '?').charAt(0).toUpperCase() }}
                  </div>
                }
              </div>
              <input #photoInput hidden type="file" accept="image/*" (change)="onPhotoSelected($event)" />
              @if (photoValidationError()) {
                <div class="photo-error" role="alert">{{ photoValidationError() }}</div>
              }
              @if (!photoRemoved()) {
                <div class="delete-button-wrapper">
                  <button
                    type="button"
                    mat-flat-button
                    class="secondary-color"
                    aria-label="Profielfoto verwijderen"
                    [disabled]="!photoPreviewUrl()"
                    (click)="removePhoto()"
                  >
                    Verwijderen
                  </button>
                </div>
              }
            </div>
            @if (photoRemoved()) {
              <div class="photo-pending-removal" role="status">
                De profielfoto wordt verwijderd zodra je op opslaan drukt.
              </div>
            }
          </section>
        }
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Annuleren</button>
    <button [class.spinner]="saving()" mat-flat-button [disabled]="!canSave()" (click)="save()" cdkFocusInitial>
      Opslaan
    </button>
  </div>
</div>
